<template>
  <div class="profile-block org-name">
    <div class="org-name__content">
      <div>
      <div class="org-name__full-name clearfix">
        <div class="org-name__name-text">
          <span v-if="org.getName()">{{ org.getName()}}</span>
        </div>
      </div>
      <div class="org-name__info">
        <div class="org-name__info-section">
          <div class="org-name__info-row">
            <span class="org-name__info-row-label">{{ $t('orgs.name_short') }}:</span>
            <span v-if="org.getAbbr()">{{ org.getAbbr() }}</span>
            <span v-else>{{ $t('labels.not_specified1') }}</span>
          </div>
          <div class="org-name__info-row org-parent clearfix">
            <span class="org-name__info-row-label">{{ $t('orgs.is_part_of') }}:</span>
            <template
              v-if="!org.getParentId()"
            >{{ $t('orgs.head_org') }}</template>
            <template v-else>
              <dep-name show-parent :orgId="org.getParentId()"></dep-name>
            </template>
          </div>
        </div>
      </div>
      </div>
      <div class="org-name__head-edit-btn">
        <el-button>
          <router-link
            v-if="admin"
            :to="{ name: 'orgEdit', params: { id: org.id }}"
          >{{ $t('labels.edit') }}</router-link>
        </el-button>
      </div>
    </div>
    <router-link
      v-if="admin"
      class="org-name__edit-profile visible-xs-block"
      :to="{ name: 'orgEdit', params: { id: org.id }}"
    >
      <i class="el-icon-edit"></i>{{ $t('orgs.subdivision_edit_short') }}
    </router-link>
    <div class="org-name__date">{{date}}</div>
  </div>
</template>
<script>
  // import info from 'src/api/info'
  import depName from 'src/components/Orgs/OrgName.vue'
  import {USER_ROLE_ADMIN} from '@/constants'

  export default {
    props: [
      'org',
      'visibleFullMap',
      'date',
      'perms'
    ],
    components: {
      depName
    },
    data () {
      return {
        chief: ''
      }
    },
    methods: {
      showFullMap () {
        this.$emit('showFullMap')
      },
      getChiefName () {
        /* if (this.org.blocks.info.chief.val) {
          info.getUserNames(this.org.blocks.info.chief.val).then(data => {
            this.chief = data[0]
          })
        } */
      }
    },
    computed: {
      admin () {
        if (this.$store.state.user.user) {
          return this.$store.state.user.user.checkRole(USER_ROLE_ADMIN)
        }
        return false
      }
    },
    mounted () {
      this.getChiefName()
    }
  }
</script>
<style lang="scss">
  @import 'src/assets/sass/paper/variables';
  @import 'src/assets/sass/core';
  .profile-block {
    &.org-name {
      padding-bottom: 15px;
    }
  }
  .org-name {
    display: block;
    &__content {
      display: grid;
      grid-template-columns: 1fr auto;
      @include respond-to(phone) {
        display: block;
      }
    }

    &__head-edit-btn {
      @include respond-to(phone) {
        display: none;
      }
    }

    &__public {
      margin-bottom: 13px;
      color: #52B12D;
      font-size: 12px;
      display: flex;
      align-items: center;

      span{margin-left: 7px;}
    }

    &__full-name {
      margin-bottom: 10px;
      font-size: 20px;
      color: #333333;
      line-height: 23px;
      font-weight: 700;
    }

    &__name-text {
      display: inline-block;
      margin-top: 5px;
      margin-bottom: 5px;
      word-wrap: break-word;
      max-width: 100%;

      @media (max-width: $screen-sm) {
        display: block;
      }
    }

    &__info-section {
      padding-bottom: 5px;
      margin-bottom: 10px;
      border-bottom: 1px solid $light-border-color;

      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }

    &__info-row {
      padding-bottom: 5px;

      &:last-child {
        padding-bottom: 0;
      }

      &.org-parent {
        .org-name__info-row-label {
          float: left;
        }
        .dep-name {
          display: block;
        }
      }
    }

    &__info-row-label {
      color: $secondary-font-color;
      margin-right: 5px;
    }

    &__chief {
      color: #52b12d;

      &:hover {
        color: #52b12d;
      }
    }

    &__chief-label {
      color: $secondary-font-color;
      margin-right: 5px;

      @media (max-width: $screen-sm) {
        display: block;
      }
    }

    &__button {
      position: absolute;
      right: 30px;
      top: 17px;
      border-color: #2f80ed;
      color: #2f80ed;

      @media (max-width: $screen-lg) {
        position: static;
        margin-top: 15px;
      }

      @media (max-width: $screen-sm) {
        margin-bottom: 15px;
      }
    }

    &__status {
      position: absolute;
      right: 30px;
      top: 17px;

      @media (max-width: $screen-lg) {
        position: static;
        margin-top: 15px;
      }

      @media (max-width: $screen-sm) {
        margin-bottom: 15px;
      }
    }

    &__status-button {
      display: inline-block;
      position: relative;
      line-height: 1;
      white-space: nowrap;
      background: #fff;
      border: 1px solid #f25556;
      color: #f25556;
      -webkit-appearance: none;
      text-align: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      padding: 12px 20px 12px 30px;
      font-size: 14px;
      border-radius: 4px;

      &:before {
        content: '';
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 6px;
        height: 6px;
        border-radius: 100%;
        background: #f25556;
      }
    }

    &__status-help {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-left: 8px;
      border: 1px solid #bfbfbf;
      border-radius: 100%;
      color: #bfbfbf;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      font-weight: 400;
      cursor: pointer;
    }

    &__edit-profile {
      padding: 15px 0 0 0;
      border-top: 1px solid $light-border-color;
      text-align: center;
      color: $secondary-font-color;

      i {
        margin-right: 10px;
      }
    }

    .super-admin-ident {
      display: block;
      margin-bottom: 10px;
    }

    &__date {
      margin-top: 10px;
      font-size: 10px;
      color: #bbbdbf;
      text-align: right;
    }
  }
</style>